import { Link } from 'react-router-dom';
import { StatusChip, formatBytes, ago, LIVE_STATUSES, LIVE, SIGNAL } from './RunCharts';

// A cloud run as one row: what it is, where it's up to, what it has cost.
export default function RunRow({ run }) {
  const live = LIVE_STATUSES.includes(run.status);
  const latest = run.latest || {};
  return (
    <Link to={`/runs/${run.run_id}`} className="block py-4 group" data-testid="run-row">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="font-mono text-sm text-white lowercase">{run.name}</span>
        <StatusChip status={run.status} />
        <span className="font-mono text-xs text-[#666666]">{run.kind === 'benchmark' ? 'speed test' : ''}</span>
        <span className="ml-auto font-mono text-xs text-[#888888]">{ago(run.created_at)}</span>
      </div>
      <div className="flex gap-4 flex-wrap mt-1.5 font-mono text-xs text-[#888888]">
        <span>{run.gpu_name}</span>
        <span style={{ color: run.spent >= run.spend_cap * 0.9 ? SIGNAL : undefined }}>${run.spent.toFixed(2)} of ${run.spend_cap}</span>
        {typeof latest.bpb === 'number' && <span className="text-white">{latest.bpb.toFixed(3)} bpb</span>}
        {latest.life_bytes ? <span>{formatBytes(latest.life_bytes)} seen</span> : null}
        {latest.stage && <span className="truncate max-w-full">{latest.stage}</span>}
        {latest.train_seconds ? <span>{(latest.train_seconds / 3600).toFixed(1)}h training of {run.hours.toFixed(1)}h rented</span> : null}
      </div>
      {live && typeof latest.progress === 'number' && (
        <div className="h-0.5 bg-[#1e251f] rounded-full overflow-hidden mt-2">
          <div className="h-full" style={{ width: `${Math.min(100, latest.progress * 100)}%`, background: LIVE }} />
        </div>
      )}
    </Link>
  );
}
